// core imports
import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { v4 } from 'uuid';

// styles
import '../../../public/scss/tab.scss';
import '../../../public/scss/radio_toggle.css';
import '../../../public/scss/radiobutton.scss';

// components
import Card from '../../components/Card';
import ProviderDescription from './ProviderDescription';
import ProviderLink from './ProviderLink';
import SelectOption from '../../components/SelectOption';

// api
import { getCityList } from './api/cityList';
import { getProviderSearch } from './api/providerSearch';
import { getRadiusList } from './api/radiusList';
import { getRefDataNetwork } from './api/networkRefData';
import { getSpecialtyType, resetSpcltyType } from './api/getSpecialtyType';
import { getFacilityType, resetFcltyType } from './api/getFacilityType';

// utils
import {
    genderType, setLocalStorage, clearLocalStorageData, getLocalStorage,
    returnNoData, getName
} from '../../utils';
import { psdata, resetBody } from './api/providerSearchData';
import { getStates } from './api/getState';
import RadioCheckOption from '../../components/RadioCheckOption';

const SearchBar = () => {
    const [networkMap, setNetworkMap] = useState([]);
    const [dataMap, setDataMap] = useState();
    const [searchKeyword, setKeyword] = useState('');
    const [distanceData, setDistance] = useState(0);
    const [networkName, setNetworkName] = useState([]);
    const [isAcceptingNewPatient, setAcceptingNewPatient] = useState('');
    const [showSubmit, setSubmitVisible] = useState(false);
    const [selectByPill, setSelectByPill] = useState();
    const [zipSelected, setZipSelected] = useState();
    const [cityList, setCityList] = useState([]);
    const [igender, setGender] = useState('');
    const [countSubmit, setCountSubmit] = useState(0);
    const [selectedTab, setSelectedTab] = useState('');
    const [radiusList, setRadiusList] = useState([]);
    const [card, setCard] = useState([]);
    const [cityLoaded, setCityLoad] = useState(false);
    const [slctdCity, setSlctdCity] = useState('');
    const [showLoc, setShowLoc] = useState(false);
    const [network, setNetwork] = useState({});
    const [providerType, setProvidrType] = useState();
    const [states, setStates] = useState([]);
    const [slctdState, setSlctd] = useState('');
    const [fcltysplty, setFacilitySpecialty] = useState('');
    const [fcltyspltyType, setFacilitySpecialtyType] = useState([]);
    const [slctdFcltySpltyType, setSlctdFacilitySpecialtyType] = useState('');
    const [selectedNetwork, setSelectedNetwork] = useState([]);
    const [fcltyspltyLoading, setfcltyspltyLoading] = useState(true);

    const selectGender = useRef(null);
    const selectBy = useRef(null);
    const selectState = useRef(null);
    const citySelect = useRef(null);
    const selectNetwork = useRef(null);
    const prvdRef = useRef(null);
    const slctZipAddState = useRef(null);
    const distanceRef = useRef(null);
    const facilityName = useRef(null);

    const navigate = useHistory();

    const dispatch = useDispatch();

    const selector = useSelector((state) => state.providerDescription);
    const selectorCity = useSelector((state) => state.cityList);
    const selectorRadius = useSelector((state) => state.radiusList);

    const ctyZp = {
        ADDRESS: 'ADDR',
        CITY: 'CITY',
        STATE: 'STATE',
        ZIP: 'ZIP'
    };

    const intoArray = (arr) => {
        const datamap = {};
        const res1 = arr.reduce((acc, cur) => {
            if (!acc.some((i) => i.networkId === cur.networkId)) {
                acc.push({
                    networkName: (cur.networkName).trim(),
                    networkId: cur.networkId,
                    dataTypeId: [cur.dataTypeId],
                    htmlBlurb: cur.htmlBlurb
                });
                datamap[cur.dataTypeId] = (cur.dataType).trim();
            } else {
                acc.forEach((x) => {
                    if (x.networkId === cur.networkId) {
                        x.dataTypeId.push(cur.dataTypeId);
                    }
                    datamap[cur.dataTypeId] = (cur.dataType).trim();
                });
            }
            return acc;
        }, []);
        setDataMap(datamap);
        setNetworkName(res1);
        const res2 = arr.reduce((acc, cur) => {
            if (acc[cur.networkId]) {
                acc[cur.networkId].push((cur.dataType).trim());
            } else {
                acc[cur.networkId] = [(cur.dataType).trim()];
            }
            return acc;
        }, []);
        const sarr = Object.entries(res2).filter(([, val]) => val.length !== 0);
        const smap = sarr.reduce((acc, [key, val]) => {
            acc[key] = val;
            return acc;
        }, {});
        setNetworkMap(smap);
    };

    useEffect(() => {
        if (selector.status === 'succeeded' && networkName.length === 0) {
            intoArray(selector.networkRef);
            setShowLoc(false);
        }
    }, [selector.status]);

    useEffect(() => {
        clearLocalStorageData();
        const data = {
            networkId: 0
        };
        dispatch(getRefDataNetwork());
        dispatch(getRadiusList(data));
    }, [dispatch]);

    useEffect(() => {
        setShowLoc(false);
        if (network.length > 0) {
            setSelectByPill();
            networkMap[network[0].networkId].forEach((i) => setCard((state) => [...state, i]));
        }
    }, [network]);

    useEffect(() => {
        setSlctd('');
        setStates([]);
        setSlctdCity('');
        setCityList([]);
        setCityLoad(false);
        setAcceptingNewPatient('');
        setSlctdFacilitySpecialtyType('');
        setFacilitySpecialtyType([]);
        setFacilitySpecialty('');
        setfcltyspltyLoading(true);
        selectState.current = null;
        dispatch(resetSpcltyType());
        dispatch(resetFcltyType());
        if ((selector.status === 'succeeded') && (prvdRef.current !== null)) {
            const dt = JSON.parse(getLocalStorage('slctd_network'));
            const data = {
                sourcetypeid: dt.networkId,
                dataName: (dt.dataType).toLowerCase()
            };
            dispatch(getStates(data));
        }
    }, [providerType, selectByPill]);

    const stateData = useSelector((state) => state.statesList);

    useEffect(() => {
        setStates([]);
        if (stateData.status === 'succeeded') {
            setStates(stateData.data);
        }
    }, [stateData.status]);

    useEffect(() => {
        const dt = JSON.parse(getLocalStorage('slctd_network'));
        if (dt !== null && slctdState) {
            const data = {
                sourcetypeid: dt.networkId,
                dataName: (dt.dataType).toLowerCase(),
                state: slctdState
            };
            dispatch(getCityList(data));
        }
    }, [selectState.current, slctdState]);

    const handleCitySlctd = (i) => {
        setSlctdCity(i);
    };

    useEffect(() => {
        setCityList([]);
        setCityLoad(false);
        if (selectorCity.status === 'succeeded') {
            setCityList(selectorCity.citylist);
            setCityLoad(true);
        } else if (selectorCity.status === 'failed') {
            setCityLoad(false);
        }
    }, [selectorCity.status]);

    useEffect(() => {
        dispatch(resetBody());
    }, []);

    useEffect(() => {
        setRadiusList([]);
        if (selectorRadius.status === 'succeeded') {
            selectorRadius.radiusList.map((i) => setRadiusList((state) => [...state, i]));
        }
    }, [selectorRadius.status]);

    const handleProviderType = (name) => {
        if ((network[0].networkId === '1' || network[0].networkId === '2') && (name === 'Pharmacy' || name === 'Vision')) {
           const tmp = selector.networkRef.filter((i) => i.dataType.trim() === name && (i.networkId !== '1' && i.networkId !== '2'));
           const slctdNetwork = {
            networkName: tmp[0].networkName,
            networkId: tmp[0].networkId,
            dataTypeId: tmp[0].dataTypeId,
            dataType: tmp[0].dataType.trim(),
            htmlBlurb: tmp[0].htmlBlurb
           };
           setSelectedNetwork(() => slctdNetwork);
           setLocalStorage('slctd_network', JSON.stringify(slctdNetwork));
        } else {
            setSelectedNetwork([]);
            networkMap[network[0].networkId].forEach((i) => {
                if (i === name) {
                    const k = {};
                    Object.entries(dataMap).forEach(([x, y]) => {
                        if (y === i) {
                            k.dataTypeId = x;
                            k.dataTypeName = y;
                        }
                    });
                    const slctdNetwork = {
                        networkName: network[0].networkName,
                        networkId: network[0].networkId,
                        dataTypeId: k.dataTypeId,
                        dataType: k.dataTypeName,
                        htmlBlurb: network[0].htmlBlurb
                    };
                    setSelectedNetwork(() => slctdNetwork);
                    setLocalStorage('slctd_network', JSON.stringify(slctdNetwork));
                }
            });
        }
        setKeyword();
        setZipSelected('');
        setSubmitVisible(false);
        setProvidrType(name);
        setSelectByPill();
        setFacilitySpecialtyType([]);
        setSelectedTab('');
        setShowLoc(true);
        prvdRef.current = name;
        if (providerType !== 'undefined') {
            setCountSubmit(countSubmit + 1);
        } else {
            setCountSubmit(countSubmit);
        }
    };

    const handleFacilitySpecialty = (value) => {
        setFacilitySpecialty(value);
        setfcltyspltyLoading(true);
        const dt = JSON.parse(getLocalStorage('slctd_network'));
        if (dt !== null && value !== '') {
            const data = {
                networkid: dt.dataTypeId,
                sourcetypeid: dt.networkId,
                informationtypecode: value
            };
            if (value === 'D') {
                dispatch(getSpecialtyType(data));
            } else if (value === 'F') {
                dispatch(getFacilityType(data));
            }
        }
    };

    const spcltySelector = useSelector((state) => state.specialtyType);
    const fcltySelector = useSelector((state) => state.facilityType);

    useEffect(() => {
        setFacilitySpecialtyType([]);
        if (spcltySelector.status === 'succeeded' && fcltysplty === 'D') {
            setFacilitySpecialtyType(spcltySelector.spcltyType);
            setfcltyspltyLoading(false);
        }
    }, [spcltySelector]);

    useEffect(() => {
        setFacilitySpecialtyType([]);
        if (fcltySelector.status === 'succeeded' && fcltysplty === 'F') {
            setFacilitySpecialtyType(fcltySelector.fcltyType);
            setfcltyspltyLoading(false);
        }
    }, [fcltySelector]);

    const handleAcceptingPatients = (value) => {
        setAcceptingNewPatient(value);
    };

    const handleNetworkDrop = (networkSelected) => {
        setCard([]);
        setSelectByPill();
        setSelectedTab('');
        const k = networkName.filter((i) => networkSelected === i.networkName);
        setNetwork(() => k);
        setSubmitVisible(false);
        setProvidrType();
        if (providerType !== 'undefined') {
            setCountSubmit(countSubmit + 1);
        } else {
            setCountSubmit(countSubmit);
        }
    };

    const handleDistance = (e) => {
        setDistance(e);
    };

    const handleCityZip = (e) => {
        setKeyword();
        setZipSelected(e);
        setSubmitVisible(false);
    };

    const handleKeyWord = (e) => {
        setKeyword();
        if (selectByPill === 'Name') {
            setZipSelected('FACILITY');
            setKeyword(e.target.value);
        }
        if (zipSelected === 'STATE') {
            setSlctdCity(e.target.value);
        } else {
        setSubmitVisible(false);
        setKeyword(e.target.value);
        }
        setSubmitVisible(false);
    };

    const handleState = (e) => {
        selectState.current = e;
        setSlctd(selectState.current);
    };

    const stateBlock = () => {
        return (
            <div className="search-block__form">
                <label htmlFor="Gender">Select State</label>
                <SelectOption
                  title="Select State"
                  classname="nnetwork_drop_menu"
                  refValue={selectState}
                  mainValue={slctdState}
                  callBackFn={handleState}
                  data={states}
                  obj=""
                />
            </div>
        );
    };

    const cityBlock = () => {
        let res = '';
        if (cityLoaded && slctdState) {
            res = (
                <div className="search-block__form">
                    <label htmlFor="city">City</label>
                    <SelectOption
                      refValue={citySelect}
                      mainValue={slctdCity}
                      classname="nnetwork_drop_menu"
                      callBackFn={handleCitySlctd}
                      data={cityList}
                      title="Select City"
                      obj=""
                    />
                </div>
            );
        }
        return res;
    };

    const showZipCityAddr = () => {
        let rtrn;
        switch (zipSelected) {
            case 'ADDR':
                rtrn = zipSelected ? (
                    <div className="search-block__form">
                        <label htmlFor="address">Address</label>
                        <input type="text" ref={slctZipAddState} className="network_input" onChange={handleKeyWord} />
                    </div>
                ) : <span />;
                break;
            case 'CITY': case 'STATE':
                rtrn = zipSelected ? (
                    <>
                        {stateBlock()}
                        {cityBlock()}
                    </>
                ) : <span />;
                break;
            case 'ZIP':
                rtrn = zipSelected ? (
                    <>
                        <div className="search-block__form">
                            <label htmlFor="zip code">Zip Code</label>
                            <input type="text" ref={slctZipAddState} className="network_input" onChange={handleKeyWord} />
                        </div>
                        <div className="search-block__form">
                            <label htmlFor="Networks">Distance in miles</label>
                            <SelectOption
                              title="Distance in miles"
                              classname="nnetwork_drop_menu"
                              refValue={distanceRef}
                              mainValue={distanceData}
                              callBackFn={handleDistance}
                              data={radiusList}
                              obj="radiusDropDown"
                            />
                        </div>
                    </>
                ) : <span />;
                break;
            default:
                rtrn = <span />;
                break;
        }
        return rtrn;
    };

    const handleGender = () => {
        const { value } = selectGender.current;
        if (value.includes('-Select')) {
            setGender('');
        } else {
            setGender(value);
        }
    };

    // check to enable submit button
    const isDataValidated = () => {
        let res = false;
        if (providerType && Object.entries(selectedNetwork).length > 1 && (zipSelected === 'ZIP') && (searchKeyword !== undefined && searchKeyword.length > 1)) {
            res = true;
        } else if (providerType && Object.entries(selectedNetwork).length > 1 && (zipSelected === 'ADDR') && (searchKeyword !== undefined && searchKeyword.length > 1)) {
            res = true;
        } else if (providerType && Object.entries(selectedNetwork).length > 1 && (zipSelected === 'STATE' && (slctdState.length >= 1 && slctdState !== ''))) {
            res = true;
        } else if (providerType && Object.entries(selectedNetwork).length > 1 && (selectedTab === 'Name' && zipSelected === 'FACILITY') && (searchKeyword !== undefined || (slctdState.length >= 1 && slctdState !== '') || slctdCity !== '')) {
            res = true;
        }
        return res;
    };

    useEffect(() => {
        if (zipSelected || searchKeyword) {
            setSubmitVisible(isDataValidated());
        }
    }, [zipSelected, searchKeyword, slctdCity, slctdState]);

    // reset values for change in location and name tabs
    const handleSelectBy = (e) => {
        selectBy.current.value = e.target.innerText;
        setSelectByPill(() => selectBy.current.value);
        setSubmitVisible(false);
        setKeyword();
        setSlctdCity('');
        setSlctd('');
        setStates([]);
        setZipSelected();
        setSlctdFacilitySpecialtyType('');
        setFacilitySpecialty('');
        setCityList([]);
        setCityLoad(false);
        setSelectedTab(e.target.innerText);
    };

    const checkAcceptingPatients = (accptnwPtnt) => {
        if (accptnwPtnt === 'Yes') {
            return 'Y';
        }
        if (accptnwPtnt === 'No') {
            return 'N';
        }
        return 'A';
    };

    // Make Search API call
    const handleSubmit = () => {
        let gen = '';
        if (igender === 'Male') {
            gen = genderType[igender];
        }
        if (igender === 'Female') {
            gen = genderType[igender];
        }
        const data = {
            acceptingnewpatient: checkAcceptingPatients(isAcceptingNewPatient),
            browseall: 0,
            city: slctdCity,
            facilityorDoctor: fcltysplty !== '' ? fcltysplty : 'A',
            filterid: distanceData > 0 ? 'DIST_ZIP' : zipSelected,
            gender: gen,
            keyword: zipSelected !== ctyZp.STATE ? searchKeyword : slctdState,
            networkid: parseInt(selectedNetwork.dataTypeId, 10),
            pageno: 1,
            radiusaroundzip: parseInt(distanceData, 10),
            state: slctdState,
            sourcetypeid: selectedNetwork.networkId,
            specialtyorfacility: slctdFcltySpltyType === ' ' ? '' : slctdFcltySpltyType
        };
        dispatch(psdata(data));
        setLocalStorage('payload_data', JSON.stringify(data));
        dispatch(getProviderSearch(data));
        navigate.push('/providerList');
    };

    const cardCondition = () => {
        if (selector.status === 'succeeded') {
            if (network.length > 0) {
                return (
                    <div className="search-block__network">
                        <div className="header-block_title">
                            Select Provider Type
                        </div>
                        <div className="search-block__network-container">
                            <div className="search-block__network-row">
                                {
                                    (card.length > 0
                                        ? card.map((i) => (
                                            <Card
                                              key={v4()}
                                              cardname={i}
                                              zipCallBack={handleProviderType}
                                              selectedProvider={providerType}
                                            />
                                        )) : 'No Data Found')
                                    }
                            </div>
                            <div className="search-block__network-desc">
                                <div className="network-desc-title">{providerType ? 'Network Details' : ''}</div>
                                <div>
                                    { providerType ? <ProviderDescription network={network} /> : '' }
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
                return (<span />);
        }
        if (selector.status === 'failed') {
            return (
                <span>Something went wrong. Please try again after sometime.</span>
            );
        }
        return (
            <span>Fetching Data...</span>
        );
    };

    const handleFacilitySpecialtyType = (e) => {
        let res = '';
        if (fcltysplty === 'D') {
            const spltyRes = fcltyspltyType.filter((i) => i.specialtyDesc === e);
            res = spltyRes[0].specialtyCode;
        }
        if (fcltysplty === 'F') {
            const spltyRes = fcltyspltyType.filter((i) => i.facilityDesc === e);
            res = spltyRes[0].facilityCode;
        }
        // to check duplicates
        // const unique = [...new Map(fcltyspltyType.map((m) => [m.specialtyDesc, m])).values()];
        // const uniqueAuthors = fcltyspltyType.reduce((acc, cur) => {
        //     if (!acc.find((item) => item.specialtyDesc === cur.specialtyDesc)) {
        //       acc.push(cur);
        //     }
        //     return acc;
        //   }, []);
        // console.log(unique);
        // console.log(uniqueAuthors);
        setSlctdFacilitySpecialtyType(res);
    };

    // For dataTypeId 3 & 4 which are Pharmacy and Vision respectively
    // we are disabling this facilityORspecialty select option
    // These 3 & 4 are taken from the referencedata/network API response
    const facilityORspecialty = () => {
        if (!['3', '4'].includes(selectedNetwork.dataTypeId)) {
            let objValue = 'specialtyDesc';
            if (fcltysplty === 'F') {
                objValue = 'facilityDesc';
            }
            return (
                <>
                    <div className="facility_specialty">
                        <label htmlFor="Facility_Type_Specialty_Type">Search by Facility Type or Specialty Type</label>
                        <RadioCheckOption
                          radioOptionValues={[
                            {
                                htmlFor: 'facility',
                                title: 'Facility Type',
                                name: 'facility_type',
                                mainValue: 'F'
                            },
                            {
                                htmlFor: 'specialty',
                                title: 'Specialty Type',
                                name: 'specialty_type',
                                mainValue: 'D'
                            }
                          ]}
                          callBckFn={handleFacilitySpecialty}
                          defaultSelect={fcltysplty}
                          classname="radio_pos"
                          radiostyle="rdo-button"
                        />
                        <div>
                            {
                                fcltysplty !== '' && fcltyspltyType.length > 0 ? (
                                    <div className="search-block__form_fs-input">
                                        <SelectOption
                                          mainValue={fcltyspltyType}
                                          classname="nnetwork_drop_menu"
                                          callBackFn={handleFacilitySpecialtyType}
                                          data={fcltyspltyType}
                                          title={`Select ${getName(fcltysplty)}`}
                                          obj={objValue}
                                        />
                                    </div>
                                ) : returnNoData(fcltyspltyType,
                                    fcltyspltyLoading,
                                    fcltysplty)
                            }
                        </div>
                    </div>
                    <hr className="solid" />
                </>
            );
        }
        return <span />;
    };

    const acceptPatientCondition = () => {
        return (
            <div className="search-block__form">
                <label htmlFor="Accepting_new_patients">Accepting new patients</label>
                <RadioCheckOption
                  radioOptionValues={[
                    {
                        htmlFor: 'acceptingPatients',
                        title: 'Yes',
                        name: 'Yes',
                        mainValue: 'Yes'
                    },
                    {
                        htmlFor: 'notAcceptingPatients',
                        title: 'No',
                        name: 'No',
                        mainValue: 'No'
                    }
                    ]}
                  callBckFn={handleAcceptingPatients}
                  defaultSelect={isAcceptingNewPatient}
                  classname="search-block__form-input"
                  radiostyle="rdo-button"
                />
            </div>
        );
    };

    const renderGenderAndPharma = () => {
        let res = '';
        if (selectedNetwork.networkId !== '3' && selectedNetwork.networkId !== '4') {
            res = (
                <>
                    <div className="search-block__queries">
                        <div className="search-block__form">
                            <label htmlFor="Gender">Select Gender</label>
                            <select className="nnetwork_drop_menu" ref={selectGender} value={igender} onChange={handleGender}>
                                <option value="">-Select Gender-</option>
                                {Object.keys(genderType).map((i) => (
                                    <option key={v4()} value={i}>{i}</option>
                                ))}
                            </select>
                        </div>
                        {acceptPatientCondition()}
                    </div>
                    <hr className="solid" />
                </>
            );
        } else {
            res = (<span />);
        }
        return res;
    };

    const tabSelected = (key, value) => {
        if (key === value) {
            return 'tab-search active';
        }
        return 'tab-search';
    };

    const searchByOptions = () => {
        if (selectByPill === 'Name') {
            return (
                <div className="search-block__network_name">
                    <div className="search-block__form_name">
                        <label htmlFor="Doctor_Or_Facility_Name">Provider or Facility Name</label>
                        <input
                          type="text"
                          className="network_input_name"
                          ref={facilityName}
                          value={searchKeyword}
                          onChange={handleKeyWord}
                        />
                    </div>
                    <div className="state_city_name">
                        {stateBlock()}
                        {cityBlock()}
                    </div>
                </div>
            );
        }
        if (selectByPill === 'Location') {
            return (
                <div>
                    <div className="search-block__network">
                        <div className="search-block__queries">
                            <div className="search-block__form">
                                <label className="label_txt" htmlFor="Networks">Select for</label>
                                <input type="text" className="network_input" value={selectedNetwork.networkName} readOnly="readonly" />
                            </div>
                            <div className="search-block__form">
                                <label htmlFor="Networks">Type</label>
                                <input type="text" className="network_input" value={providerType} readOnly="readonly" />
                            </div>
                        </div>
                        <hr className="solid" />
                        {facilityORspecialty()}
                        {renderGenderAndPharma()}
                        <RadioCheckOption
                          radioOptionValues={[
                            {
                                htmlFor: 'radio-one-zip',
                                title: 'Zip',
                                name: 'zip',
                                mainValue: ctyZp.ZIP
                            },
                            {
                                htmlFor: 'radio-one-address',
                                title: 'Address',
                                name: 'Address',
                                mainValue: ctyZp.ADDRESS
                            },
                            {
                                htmlFor: 'radio-one-state',
                                title: 'State',
                                name: 'state',
                                mainValue: ctyZp.STATE
                            }
                            ]}
                          callBckFn={handleCityZip}
                          defaultSelect={zipSelected}
                          classname="search-block__queries"
                          radiostyle="rdo-button"
                        />
                        <div className="search-block__queries">
                            {zipSelected === 'undefined' ? '' : showZipCityAddr()}
                        </div>
                    </div>
                </div>
            );
        }
        return (<hr className="solid" />);
    };

    // Tabs (Location, Name)
    const searchByDiv = () => {
        if (Object.keys(network).length > 0 && showLoc) {
            return (
                <div>
                    <hr className="solid" />
                    <div>
                        <div className="search-block__network">
                            <div className="header-block_title">Search by</div>
                            <div className="main-tabs" ref={selectBy}>
                                <div
                                  role="button"
                                  tabIndex={0}
                                  className={tabSelected(selectedTab, 'Location')}
                                  value="location"
                                  onClick={handleSelectBy}
                                  onKeyDown={handleSelectBy}
                                >
                                    Location
                                </div>
                                <div
                                  role="button"
                                  tabIndex={0}
                                  className={tabSelected(selectedTab, 'Name')}
                                  value="name"
                                  onClick={handleSelectBy}
                                  onKeyDown={handleSelectBy}
                                >
                                    Name
                                </div>
                            </div>
                        </div>
                    </div>
                    { searchByOptions() }
                </div>
            );
        }
        return (<span />);
    };

    return (
        <div className="search-block">
            <div className="container">
                <ProviderLink />
                <div className="search-block__inner">
                    <div className="header-block_title">For plans issued in all other states, please use the directory below.</div>
                    <div className="search-block__form">
                        <label className="label_txt" htmlFor="Networks">Networks</label>
                        <div className="search-block__form-inner">
                            {
                                Object.keys(networkName).length > 0 ? (
                                    <SelectOption
                                      title="Select Network"
                                      classname="filter_by"
                                      refValue={selectNetwork}
                                      mainValue={networkName}
                                      callBackFn={handleNetworkDrop}
                                      data={networkName}
                                      obj="networkName"
                                    />
                                ) : <span />
                            }
                            {network.length >= 0 ? <hr className="solid" /> : ''}
                        </div>
                    </div>
                    <div>
                        {
                            cardCondition()
                        }
                    </div>
                </div>
                <div>
                    {searchByDiv()}
                </div>
                <div className="search-block__submit">
                    <button
                      type="submit"
                      name="Search"
                      value="search"
                      className="button button--primary"
                      onClick={handleSubmit}
                      disabled={!showSubmit}
                    >
                        Search
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SearchBar;
